import axios from 'axios';
export const fqdnLink = (): string | undefined => {
  if (!process.env.REACT_APP_LOCAL) {
    const newlink = window.location.href.split('.co/')[1]
      ? window.location.href.split('.co/')[1]
      : window.location.href.split('.')[0];
    let splitlink: string | string[] = newlink.split('/') ? newlink.split('/') : '';
    return (splitlink = splitlink[0]);
  }
  return process.env.REACT_APP_TENANT_NAME;
};

export const addAuthTokenToRequestHeaders = (token: string): void => {
  axios.defaults.headers.common['Authorization'] = token;
};
axios.defaults.headers.common['fqdn'] = fqdnLink();
export const removeAuthTokenFromRequestHeaders = (): void => {
  delete axios.defaults.headers.common['Authorization'];
};

// export const getBaseUrl = (): string => {
//   // const currentLocation = window.location;
//   // if (currentLocation.host.match(/^localhost|^company1/)) {
//     return process.env.REACT_APP_API_BASE_URL as string;
//   // }
//   // console.log('b');
//   // return `${currentLocation.protocol}//${currentLocation.host.replace(
//   //   /.easyidentity.co/,
//   //   '-api-dev.easyidentity.co'
//   // )}
//   // /api/v1/`;
// };

export const getBaseUrl = (): string => {
  //const origin = window.location.origin.split('.');
  const ApiEndPoint = process.env.REACT_APP_API_BASE_URL;
  // if (origin.length > 1) {
  //   origin[0] += '-api';
  //   ApiEndPoint = origin.join('.').replaceAll('easyidentity.co', 'easyidentity.co/client/api/v1');
  // }
  return ApiEndPoint as string;
};
